import React from 'react';
import { FileText } from 'lucide-react';
import { toast } from 'sonner';

const CompanySettings = ({ formData, handleChange }) => {
  return (
    <div className="card">
      <div className="card-body">
        <h3 style={{ marginBottom: '1.5rem', fontSize: '1.25rem', fontWeight: 600 }}>
          Şirket Bilgileri
        </h3>
        
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Şirket Adı</label>
            <input
              type="text"
              className="form-input"
              value={formData.company_name}
              onChange={(e) => handleChange('company_name', e.target.value)}
              data-testid="company-name"
            />
          </div>
          <div className="form-group">
            <label className="form-label">E-posta</label>
            <input
              type="email"
              className="form-input"
              value={formData.company_email}
              onChange={(e) => handleChange('company_email', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Telefon</label>
            <input
              type="text"
              className="form-input"
              value={formData.company_phone}
              onChange={(e) => handleChange('company_phone', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Vergi No</label>
            <input
              type="text"
              className="form-input"
              value={formData.tax_number}
              onChange={(e) => handleChange('tax_number', e.target.value)}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Vergi Dairesi</label>
            <input
              type="text"
              className="form-input"
              value={formData.tax_office}
              onChange={(e) => handleChange('tax_office', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Varsayılan Para Birimi</label>
            <select
              className="form-input"
              value={formData.default_currency}
              onChange={(e) => handleChange('default_currency', e.target.value)}
            >
              <option value="USD">USD - Amerikan Doları</option>
              <option value="EUR">EUR - Euro</option>
              <option value="TRY">TRY - Türk Lirası</option>
              <option value="GBP">GBP - İngiliz Sterlini</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Adres</label>
          <textarea
            className="form-input"
            value={formData.company_address}
            onChange={(e) => handleChange('company_address', e.target.value)}
            rows="3"
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Fatura Numara Formatı</label>
            <input
              type="text"
              className="form-input"
              value={formData.invoice_number_format}
              onChange={(e) => handleChange('invoice_number_format', e.target.value)}
              placeholder="INV-{year}-{number:04d}"
            />
            <small style={{ fontSize: '0.75rem', color: '#64748b' }}>
              Kullanılabilir: {'{year}'}, {'{number:04d}'}
            </small>
          </div>
        </div>

        {/* Proforma Numaralandırma Bölümü */}
        <h3 style={{ marginTop: '2rem', marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FileText size={20} />
          Proforma Numaralandırma
        </h3>
        
        <div style={{ 
          background: '#f0f9ff', 
          border: '1px solid #bae6fd', 
          borderRadius: '8px', 
          padding: '1rem', 
          marginBottom: '1rem' 
        }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={formData.proforma_use_custom_format}
              onChange={(e) => handleChange('proforma_use_custom_format', e.target.checked)}
              style={{ width: '18px', height: '18px' }}
            />
            <span style={{ fontWeight: 500 }}>Özel Proforma Numaralandırma Kullan</span>
          </label>
          <p style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '0.5rem', marginLeft: '2rem' }}>
            Aktif olduğunda: <strong>ROPS-2026/00001</strong> formatında numara üretilir
          </p>
        </div>

        {formData.proforma_use_custom_format && (
          <div style={{ 
            background: '#fff', 
            border: '1px solid #e2e8f0', 
            borderRadius: '8px', 
            padding: '1.5rem',
            marginBottom: '1.5rem'
          }}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Önek (Prefix)</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.proforma_number_prefix}
                  onChange={(e) => handleChange('proforma_number_prefix', e.target.value)}
                  placeholder="ROPS"
                />
                <small style={{ fontSize: '0.75rem', color: '#64748b' }}>
                  Örn: ROPS, PF, PRF
                </small>
              </div>
              <div className="form-group">
                <label className="form-label">Yıl</label>
                <input
                  type="number"
                  className="form-input"
                  value={formData.proforma_number_year}
                  onChange={(e) => handleChange('proforma_number_year', parseInt(e.target.value) || new Date().getFullYear())}
                  min="2020"
                  max="2050"
                />
                <small style={{ fontSize: '0.75rem', color: '#64748b' }}>
                  Numara formatında kullanılacak yıl
                </small>
              </div>
              <div className="form-group">
                <label className="form-label">Başlangıç Numarası</label>
                <input
                  type="number"
                  className="form-input"
                  value={formData.proforma_number_start}
                  onChange={(e) => handleChange('proforma_number_start', parseInt(e.target.value) || 1)}
                  min="1"
                />
                <small style={{ fontSize: '0.75rem', color: '#64748b' }}>
                  Sonraki proforma bu numaradan başlar
                </small>
              </div>
            </div>
            
            <div style={{ 
              background: '#f8fafc', 
              padding: '1rem', 
              borderRadius: '6px', 
              marginTop: '1rem',
              border: '1px dashed #cbd5e1'
            }}>
              <span style={{ color: '#64748b', fontSize: '0.85rem' }}>Önizleme: </span>
              <strong style={{ color: '#1a365d', fontSize: '1.1rem' }}>
                {formData.proforma_number_prefix}-{formData.proforma_number_year}/{String(formData.proforma_number_start).padStart(5, '0')}
              </strong>
            </div>
          </div>
        )}

        {!formData.proforma_use_custom_format && (
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Proforma Numara Formatı (Standart)</label>
              <input
                type="text"
                className="form-input"
                value={formData.proforma_number_format}
                onChange={(e) => handleChange('proforma_number_format', e.target.value)}
                placeholder="PF-{year}-{number:04d}"
              />
              <small style={{ fontSize: '0.75rem', color: '#64748b' }}>
                Kullanılabilir: {'{year}'}, {'{number:04d}'}
              </small>
            </div>
          </div>
        )}

        <div className="form-group">
          <label className="form-label">Belge Alt Yazı (Footer)</label>
          <textarea
            className="form-input"
            value={formData.document_footer}
            onChange={(e) => handleChange('document_footer', e.target.value)}
            rows="3"
            placeholder="PDF belgelerinin alt kısmında görünecek metin..."
          />
        </div>

        <h3 style={{ marginTop: '2rem', marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>
          Döviz Kuru Ayarları
        </h3>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Döviz Kuru API URL</label>
            <input
              type="text"
              className="form-input"
              value={formData.exchange_rate_url}
              onChange={(e) => handleChange('exchange_rate_url', e.target.value)}
              placeholder="https://www.tcmb.gov.tr/kurlar/today.xml"
            />
            <small style={{ fontSize: '0.75rem', color: '#64748b' }}>
              TCMB resmi XML API URL&apos;si (varsayılan önerilir)
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySettings;
